import { useEffect, useState } from 'react';

export type UseDotsOpts = {
  maxDots?: number;
};

export const useDots = ({ maxDots = 3 }: UseDotsOpts = {}) => {
  const [counter, setCounter] = useState<number>(maxDots - 1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((prev) => prev + 1);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const numDots = (counter % maxDots) + 1;

  return '.'.repeat(numDots) + ' '.repeat(maxDots - numDots);
};
